<res-base-modal [modalTitle]="modalTitle" [modalClass]="modalClass" [modalAutomationId]="automationId.modal"
    [primaryButtonLabel]="primaryButtonLabel" (primaryButtonActionEmt)="ok()" (closeButtonActionEmt)="closeModal()"
    [secondaryButtonLabel]="secondaryButtonLabel" [isPrimaryBtnEnabled]="isPrimaryButtonEnabled()" [(isBusy)]="isBusy"
    [(isBusyMessage)]="isBusyMessage" [modalHelpIndex]="helpIndex"
    [isAddTextToSyntheticDocumentModal]="modalType == 'Profile' ? true : false">
    <div class="add-selected-text-left">
        <res-generic-grid [gridName]="gridName" [automationId]="automationId.grid" [pagerVisible]="false"
            [headerTemplate]="modalData?.isAddToExistingDomainList ? null : headerTemplate"
            [columnDefs]="columnDefs.left" [rowSelection]="rowSelection" [requestInfo]="requestInfo"
            [gridContext]="gridContext" [responseArrayCallback]="responseArrayCallback"
            [onSelectionChanged]="onSelectionChanged" [loadDataFinishedCallback]="loadDataFinishedCallback">
        </res-generic-grid>
    </div>
    <div class="add-selected-text-separator"></div>
    <div class="add-selected-text-right" [resBusySpinner]="isBusyDetails" [message]="isBusyMessageDetails"
        [attr.data-automation-id]="modalType == 'Profile' ? 'profile-modal-container' : ''">
        <res-generic-grid *ngIf="modalType != 'Profile'"
            [automationId]="modalType != 'DomainList' ? automationId.grid : automationId.customDomainListAutoId"
            [pagerVisible]="false" [rowClassRules]="rowDisableRules" [columnDefs]="columnDefs.right"
            [gridContext]="gridContext">
        </res-generic-grid>
        <div *ngIf="modalType == 'Profile' && selectedItem" class="profile-details">
            <div class="modal-row modal-fill">
                <div class="modal-row-column-auto">
                    <label [attr.data-automation-id]="'text-label-profile'" requiredAsterisk>Synthetic Document text:
                    </label>
                </div>
                <div class="modal-row-column-max">
                    <textarea [(ngModel)]="selectedItem.content"
                        [attr.data-automation-id]="'profile-text-input'"></textarea>
                </div>
            </div>
            <div class="modal-row">
                <div class="modal-row-column-auto">
                    <label [attr.data-automation-id]="'comment-label-profile'">Comment:
                    </label>
                </div>
                <div class="modal-row-column-max">
                    <input type="text" [(ngModel)]="selectedItem.lastComments"
                        [attr.data-automation-id]="'profile-comment-input'">
                </div>
            </div>
        </div>
        <div class="no-selection" *ngIf="!selectedItem">
            <div><i class="fa fa-arrow-left"></i><span>{{noSelectionText}}</span></div>
        </div>
    </div>
</res-base-modal>
<ng-template #headerTemplate>
    <button type="button"
        [attr.data-automation-id]="modalType == 'Profile' ? 'add-new-Synthetic Document-button' : modalType == 'AliasList' ? automationId.grid + '-add-new-alias-list-button' : automationId.grid + '-new-domain-list-button'"
        class="secondary-button" (click)="addNewItem()">
        <i class="fa fa-plus"></i>{{addNewItemButtonText}}
    </button>
</ng-template>